<template>
  <HeadlineComponent>Broadcast Mail</HeadlineComponent>
  <Form
    @submit="onSubmit"
    class="form-horizontal"
    v-slot="{ values }"
    :initialValues="iV"
    v-if="loaded"
  >
    <div class="form-group">
      <label for="subject" class="control-label col-sm-2">Betreff</label>
      <div class="col-sm-10">
        <BootstrapField
          type="text"
          name="subject"
          class="form-control"
          id="subject"
        />
      </div>
    </div>
    <div class="form-group">
      <label for="text" class="control-label col-sm-2">Text</label>
      <div class="col-sm-10">
        <QuillField
          name="message"
          placeholder="Sehr geehrte Damen und Herren,..."
        />
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-offset-2 col-sm-10">
        <div class="checkbox">
          <label for="teamleads_only">
            <Field
              type="checkbox"
              name="teamleads_only"
              :value="true"
              id="teamleads_only"
            />
            Nur an Teamleads
          </label>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-offset-2 col-sm-10">
        <div class="checkbox">
          <label for="crew_with_shifts_only">
            <Field
              type="checkbox"
              name="crew_with_shifts_only"
              id="crew_with_shifts_only"
              :value="true"
            />
            Nur an Crew mit Schichten (und Teamleads/Admins)
          </label>
        </div>
      </div>
    <div class="form-group" v-if="values && values.crew_with_shifts_only">
      <div class="col-sm-offset-2 col-sm-10">
        <Field as="select" name="event_id" id="type" class="form-control">
          <option value="">-- Auswählen --</option>
          <option v-for="event of events" :key="event.id" :value="event.id">
            {{
              $filters.formatDate(event.start_date, "DD.MM.YYYY") +
              " - " +
              event.name
            }}
          </option>
        </Field>
      </div>
    </div>
    <div class="form-group" v-if="values && values.crew_with_shifts_only">
      <div class="col-sm-offset-2 col-sm-10">
        <div class="checkbox">
          <label for="crew_with_exakt_required_shifts_only">
            <Field
              type="checkbox"
              name="crew_with_exakt_required_shifts_only"
              id="crew_with_exakt_required_shifts_only"
              :value="true"
            />
            Nur an Crew mit exakt sovielen Schichten wie nötig (und
            Teamleads/Admins)
          </label>
        </div>
      </div>
    </div>

    </div>
    <div class="form-group">
      <div class="col-sm-offset-2 col-sm-10">
        <label for="crew_with_no_shifts"><Field type="checkbox" name="crew_with_no_shifts" id="crew_with_no_shifts" :value="true" />
          Nur an Crew ohne in Zukunft liegender Schichten
        </label>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-10 col-sm-offset-2">
        <LoadingButton class="btn-primary" :loading="loading"
          >Senden</LoadingButton
        >
      </div>
    </div>
  </Form>
</template>

<script>
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import userService from "@/services/user.service.js";
import LoadingButton from "@/components/LoadingButton.vue";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import eventService from "@/services/event.service";
import { Field, Form } from "vee-validate";
import BootstrapField from "../../components/BootstrapField.vue";
import QuillField from "../../components/QuillField.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "BroadcastMailView",
  components: {
    LoadingButton,
    HeadlineComponent,
    // eslint-disable-next-line vue/no-reserved-component-names
    Form,
    BootstrapField,
    QuillField,
    Field,
  },
  data() {
    return {
      loading: false,
      user: [],
      events: [],
      iV: { crew_with_shifts_only: false, crew_with_no_shifts: false },
      loaded: false,
    };
  },
  async beforeRouteEnter(to, from, next) {
    let user = [];
    let events = [];
    try {
      let response = await userService.index(true);
      user = response.data;
      response = await eventService.index(true);
      events = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        useAlertsStore().add(
          "danger",
          "Es ist was unerwartetes schief gegangen.."
        );
        window.scrollTo(0, 0);
      }
    }
    let event_id = to.query.event_id ? to.query.event_id : "";
    let crewWithShiftsOnly = to.query.event_id ? true : false;
    next((vm) => {
      vm.user = user;
      vm.events = events;
      vm.iV = { crew_with_shifts_only: crewWithShiftsOnly, crew_with_no_shifts: false, event_id: event_id };
      vm.loaded = true;
    });
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async onSubmit(values) {
      this.loading = true;
      try {
        let response = await userService.broadcastMail(values);
        this.addAlert("success", response.data.message);
      } catch (e) {
        if (e) {
          if (e.response && e.response.data && e.response.data.message) {
            this.addAlert("danger", e.response.data.message);
            window.scrollTo(0, 0);
          } else {
            Sentry.captureException(e);
            this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
            window.scrollTo(0, 0);
          }
        }
      }
      this.loading = false;
    },
  },
  watch: {
    teamleadsOnly() {
      if (this.teamleadsOnly) {
        this.crewWithExaktRequiredShiftsOnly = false;
        this.crewWithShiftsOnly = false;
      }
    },
    crewWithShiftsOnly() {
      if (this.crewWithShiftsOnly) {
        this.teamleadsOnly = false;
      } else {
        this.crewWithExaktRequiredShiftsOnly = false;
      }
    },
  },
};
</script>

<style scoped>
:deep() .ql-editor {
  background-color: #fff;
}
</style>
